import { useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Loader, { useRouteLoader } from "./Components/Loader";
import Navbar, { LOGO } from "./Components/Navbar";
import { QuoteProvider } from "./Components/QuoteModal";
import { HERO_SLIDES } from "./Components/brand";
import Landing from "./Components/Landing";
import About from "./Components/About";
import Services from "./Components/Services";
import Shop from "./Components/Shop";
import NotFound from "./Components/NotFound";
import { IS_SNAP } from "./seo/snap";

const PRELOAD = [LOGO, ...HERO_SLIDES.map((s) => s.src)];

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout() {
  const { pathname } = useLocation();
  const { loading, first } = useRouteLoader(pathname, PRELOAD);

  // During the pre-render snapshot, never show the loader.
  const ready = IS_SNAP || !loading;

  // Removes the white cover from index.html once React has taken over.
  useEffect(() => {
    if (!IS_SNAP) document.getElementById("boot")?.remove();
  }, []);

  return (
    <>
      <AnimatePresence>
        {loading && !IS_SNAP && <Loader key="loader" quick={!first} />}
      </AnimatePresence>

      <ScrollToTop />
      <Navbar ready={ready} />

      <Routes>
        <Route path="/" element={<Landing ready={ready} />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <QuoteProvider>
        <Layout />
      </QuoteProvider>
    </BrowserRouter>
  );
}